import api from "./client";

export function setupMfa() {
  return api.post("/mfa/setup");
}

export function confirmMfa(code) {
  return api.post("/mfa/confirm", { code });
}
